import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate } from '../api/dataverseClient';
import { ChangeRequest } from '../types';

const FIELDS = [
  'dagrun_pm_changerequestid','dagrun_pm_name','dagrun_pm_description',
  'dagrun_pm_impactassessment','dagrun_pm_status','dagrun_pm_submittedby',
  'dagrun_pm_submittedon','dagrun_pm_reviewedby','dagrun_pm_reviewedon',
  'dagrun_pm_approvalnotes','createdon','_dagrun_pm_projectid_value',
];

export async function getProjectChangeRequests(pca: IPublicClientApplication, projectId: string): Promise<ChangeRequest[]> {
  return dvList<ChangeRequest>(pca, 'dagrun_pm_changerequests', {
    select: FIELDS,
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
    orderby: 'createdon desc',
  });
}

export async function createChangeRequest(pca: IPublicClientApplication, projectId: string, name: string): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_changerequests', {
    dagrun_pm_name: name,
    dagrun_pm_status: 100000000,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${projectId})`,
  });
}

export async function updateChangeRequest(pca: IPublicClientApplication, id: string, patch: Record<string, unknown>): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_changerequests', id, patch);
}

export async function submitChangeRequest(
  pca: IPublicClientApplication,
  projectId: string,
  fields: { name: string; description: string; impactassessment?: string | null; submittedby: string; submittedbyname: string },
): Promise<string> {
  const body: Record<string, unknown> = {
    dagrun_pm_name: fields.name,
    dagrun_pm_description: fields.description,
    dagrun_pm_status: 100000000, // Submitted
    dagrun_pm_submittedby: fields.submittedby,
    dagrun_pm_submittedon: new Date().toISOString(),
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${projectId})`,
  };
  if (fields.impactassessment) body.dagrun_pm_impactassessment = fields.impactassessment;
  return dvCreate(pca, 'dagrun_pm_changerequests', body);
}
